@if (activeWidget?.widget; as config) {
  <div
    class="flex flex-column justify-content-start align-content-start align-items-stretch text-left">
    <div class="flex align-items-center gap-3">
      <app-header text="Raum" icon="fa-regular fa-map"></app-header>
      <app-context-switch [activeWidgetConfig]="config"></app-context-switch>
    </div>
    @if (config.context !== 'external') {
      <div class="mt-5">
        <app-type-dropdown
          [displayNewLayerTypeOption]="true"
          [enableEmpty]="false"
          [globalSelector]="false"
          [mode]="'all'"
          [(selection)]="selectedDataLayerType"
          (selectionChange)="setDataLayerType($event)"></app-type-dropdown>
      </div>

      @if (selectedDataLayer?.geoData; as geoDataId) {
        <app-geo-group-dropdown
          headerStyleClass="mt-5"
          [selection]="config.activeGroup"
          (selectionChange)="setActiveGroup($event)"
          [geoDataId]="geoDataId" />
      }
    } @else if (config.context === 'external') {
      <div class="grid">
        <app-form-field-wrapper label="durchsuchen ..." [colSize]="12">
          <input
            pInputText
            [(ngModel)]="regionSearchString"
            appDebounceInput
            [debounceMs]="300"
            (debounceInput)="searchForWegweiserRegion()" />
        </app-form-field-wrapper>
      </div>
      @if (regionSearchString.length && this.filterBySelection(regionResult)) {
        <p-divider />
        <div class="max-h-15rem p-card p-2 overflow-auto">
          @for (region of this.filterBySelection(regionResult); track $index) {
            <div
              class="flex gap-2 align-items-center surface-border"
              [ngClass]="{ 'pb-3 mb-3 border-bottom-1': !$last }">
              <span class="flex align-items-center gap-2">
                <i class="fa-regular fa-map"></i> {{ region.name }}
              </span>

              <button
                pButton
                (click)="selectRegion(region)"
                class="p-button-xs ml-auto"
                [rounded]="true"
                icon="fas fa-plus"></button>
            </div>
          }
        </div>
      }

      @if (
        this.filterBySelection(wegweiserStore.regionCache());
        as regionsFromCache
      ) {
        <app-header
          text="nochmal auswählen"
          icon="fas fa-info-circle"></app-header>
        @for (region of regionsFromCache; track $index) {
          <div
            class="flex gap-2 align-items-center surface-border"
            [ngClass]="{ 'pb-3 mb-3 border-bottom-1': !$last }">
            <span class="flex align-items-center gap-2">
              <i class="fas fa-arrow-right"></i>
              {{ region.name }}
            </span>
            <button
              pButton
              (click)="selectRegion(region)"
              class="p-button-xs ml-auto"
              [rounded]="true"
              icon="fas fa-recycle"></button>
          </div>
        }
        <p-divider />
      }

      @if (
        activeWidget?.widget?.wegweiserRequestParams?.regionIds;
        as selectedRegionIds
      ) {
        @if (selectedRegionIds.length) {
          <app-header
            text="Auswahl für diese Darstellung"
            icon="fa-regular fa-map"></app-header>
          @for (regionId of selectedRegionIds; track $index) {
            <div
              class="flex gap-2 align-items-center surface-border"
              [ngClass]="{ 'pb-3 mb-3 border-bottom-1': !$last }">
              <span class="flex align-items-center gap-2">
                <i class="fas fa-check-circle"></i>
                {{ wegweiserStore.getWegweiserRegionById(regionId)?.name }}
              </span>
              <button
                pButton
                (click)="unselectRegion(regionId)"
                class="p-button-xs ml-auto"
                [rounded]="true"
                icon="fas fa-trash"
                severity="danger"></button>
            </div>
          }
        }
      }
    }

    @if (availableConfig.includes('poi')) {
      <app-type-multi-select
        mode="Point"
        [disableTypes]="[config.dataLayerType]"
        [header]="{ icon: 'fas fa-location-dot', text: 'Standorte' }"
        [(ngModel)]="poiToShow"
        (ngModelChange)="savePoiSelectionToConfig($event)"
        name="poiToShow"></app-type-multi-select>
      @if (poiToShow?.length) {
        <div
          cdkDropList
          [cdkDropListData]="poiToShow"
          (cdkDropListDropped)="onDrop($event)"
          class="mt-4">
          @for (poi of poiToShow; track $index) {
            <div
              class="flex gap-2 align-items-center surface-border"
              [ngClass]="{ 'pb-3 mb-3 border-bottom-1': !$last }"
              [cdkDragData]="poi"
              cdkDrag>
              @if (poi.icon) {
                <app-svg-icon [key]="poi.icon"></app-svg-icon>
              }
              {{ poi.name }}
              <app-geo-group-dropdown
                class="ml-auto"
                label=""
                [selection]="poiGroupConf[poi._id] || ''"
                (selectionChange)="savePoiGroup($event, poi._id)"
                [geoDataId]="getPoiGeoDataByYear(config.year, poi._id)" />
              @if (poiAvailableInYear(config.year, poi._id)) {
                <app-indicator-data-dropdown
                  [enableEmpty]="true"
                  (selectionChange)="savePoiIndicator($event, poi._id)"
                  [selection]="getPoiIndicatorByIndex(poi._id)"
                  [layerId]="
                    getPoiLayerByYear(config.year, poi._id)
                  "></app-indicator-data-dropdown>
              } @else {
                <span
                  class="ml-auto text-color-secondary font-italic flex align-items-center gap-2 mr-2"
                  ><i class="fas fa-info-circle"></i> Im aktuellen Jahr nicht
                  verfügbar</span
                >
              }
            </div>
          }
        </div>
      }
    }
    <!--
    <app-header
      text="Datenquelle: Wegweiser Kommune"
      icon="fas fa-database"
      sub="Nutzen Sie Daten aus dem Wegweiser Kommune für Ihre Darstellung."></app-header>
    <div class="grid">
      <app-form-field-wrapper
        name="groupProperty"
        [floatingLabel]="false"
        [colSize]="12">
        <p-selectButton
          [ngModel]="config.context"
          [allowEmpty]="false"
          (onChange)="setContext($event.value)"
          [options]="contextOptions"
          optionLabel="label"
          optionValue="key">
          <ng-template let-item pTemplate>
            <strong class="p-3 -m-3" [pTooltip]="item.tooltip">{{
              item.label
            }}</strong>
          </ng-template>
        </p-selectButton>
        <p-checkbox todo: häkchen
          [(ngModel)]="config.context"
          label="externe Daten nutzen"
          trueValue="external"
          falseValue="local">
        </p-checkbox>
      </app-form-field-wrapper>-->
  </div>
}
